/**
 *
 * CustomLocalizationProvider
 *
 */

import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

class CustomAdapterLuxon extends AdapterLuxon {
  getWeekdays = () => ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

  getWeekArray = (date) => {
    const { days } = date
      .endOf('month')
      .endOf('week')
      .diff(date.startOf('month').startOf('week'), 'days')
      .toObject();

    let weeks = [];

    // generate one week of extra dates to consider edge cases caused by startOf('week') function
    // and filter out all dates later which is outside month range
    const offsetDaysOfMonth = 7;
    new Array(
      Math.round(Number.isFinite(days) ? days + offsetDaysOfMonth : days),
    )
      .fill(0)
      .map((_, i) => i)
      .map(
        (day) =>
          date
            .startOf('month')
            .startOf('week')
            .plus({ days: day - 1 }), // shift all dates to one day of its Preceding date
      )
      .forEach((v, i) => {
        if (i === 0 || (i % 7 === 0 && i > 6)) {
          weeks.push([v]);
          return;
        }

        weeks[weeks.length - 1].push(v);
      });

    weeks = weeks.filter(
      (week) =>
        // do not allow weeks with start or end outside of current month
        week[0].hasSame(date, 'month') ||
        week[week.length - 1].hasSame(date, 'month'),
    );

    return weeks;
  };
}

const CustomLocalizationProvider = ({ children }) => (
  <LocalizationProvider dateAdapter={CustomAdapterLuxon}>
    {React.Children.only(children)}
  </LocalizationProvider>
);

CustomLocalizationProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default memo(CustomLocalizationProvider);
